import { render, staticRenderFns } from "./DrawFirework.vue?vue&type=template&id=6875af96&scoped=true&"
import script from "./DrawFirework.vue?vue&type=script&lang=js&"
export * from "./DrawFirework.vue?vue&type=script&lang=js&"
import style0 from "./DrawFirework.vue?vue&type=style&index=0&id=6875af96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875af96",
  null
  
)

component.options.__file = "DrawFirework.vue"
export default component.exports